import { Reducer } from 'redux';

import { AnalyticsState } from './analyticsTypes';

export const initialState: AnalyticsState = {
  keyIndicatorsData: null,
};

const analyticsReducer: Reducer<AnalyticsState> = (state = initialState) => {
  return state;
};

export default analyticsReducer;
